export enum ChallanStatus {
    Unpaid = 'UNPAID'
}
